import axios from 'axios';
import { BASE_URL_SERVER } from '../helpers/constants';

const baseURL = BASE_URL_SERVER;

export async function getAllNews(params) {
  const res = await axios.get(baseURL + '/news', { params });
  return res.data;
}
export async function getNewsDetails(id) {
  const res = await axios.get(baseURL + `/news/${id}`);
  return res.data;
}
export async function createNews(data) {
  const res = await axios.post(baseURL + `/news`, data);

  return res.data;
}
export async function deleteNews(newsId) {
  const res = await axios.delete(baseURL + `/news/${newsId}`);

  return res.data;
}
